export default __webpack_public_path__ + "static/media/Vipin Sharma.1d180996.jpg";